import { useCallback } from "react"

import { login } from "@/services"
import Toast from "@/topic/rogue_4/components/Toast"
import { auth } from "@/utils/auth"

export const useLogin = (type: string) => {
    const handleLogin = useCallback(async (token: string, nextFn?: any) => {
        auth.setToken(token)

        const { code, msg } = await login(token)

        if (code !== 0) {
            Toast.message({
                content: msg,
            })
        } else {
            nextFn?.()
        }
    }, [])

    return handleLogin
}
